import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../context/CartContext';
import { useToast } from '../context/ToastContext';
import { FiX, FiTrash2, FiPlus, FiMinus, FiShoppingBag } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const CartDrawer = () => {
  const { state, dispatch, totalPrice } = useCart();
  const { addToast } = useToast();

  const handleRemove = (id, name) => {
    dispatch({ type: 'REMOVE_FROM_CART', payload: id });
    addToast(`${name} removed from cart`, 'error');
  };

  const handleQuantity = (id, delta, current) => {
    dispatch({ type: 'UPDATE_QUANTITY', payload: { id, quantity: current + delta } });
  };

  return (
    <AnimatePresence>
      {state.isOpen && (
        <>
          <motion.div
            className="drawer-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => dispatch({ type: 'CLOSE_DRAWER' })}
          />
          <motion.div
            className="cart-drawer"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 30, stiffness: 300 }}
          >
            {/* Header */}
            <div className="drawer-header">
              <div className="drawer-title">
                <FiShoppingBag size={22} />
                <span>Your Cart</span>
                {state.items.length > 0 && (
                  <span className="drawer-count">{state.items.length}</span>
                )}
              </div>
              <button className="drawer-close" onClick={() => dispatch({ type: 'CLOSE_DRAWER' })}>
                <FiX size={22} />
              </button>
            </div>

            {/* Items */}
            <div className="drawer-items">
              {state.items.length === 0 ? (
                <div className="drawer-empty">
                  <div className="empty-icon">🛍️</div>
                  <h3>Your cart is empty</h3>
                  <p>Add some amazing products!</p>
                  <Link
                    to="/shop"
                    className="btn btn-primary"
                    onClick={() => dispatch({ type: 'CLOSE_DRAWER' })}
                  >
                    Browse Shop
                  </Link>
                </div>
              ) : (
                <AnimatePresence>
                  {state.items.map(item => (
                    <motion.div
                      key={item.id}
                      className="cart-item"
                      layout
                      initial={{ opacity: 0, x: 50 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -50 }}
                    >
                      <img src={item.image} alt={item.name} className="cart-item-img" />
                      <div className="cart-item-info">
                        <p className="cart-item-name">{item.name}</p>
                        <p className="cart-item-price">¥{(item.price * item.quantity).toFixed(2)}</p>
                        <div className="cart-item-qty">
                          <button
                            className="qty-btn"
                            onClick={() => handleQuantity(item.id, -1, item.quantity)}
                          >
                            <FiMinus size={12} />
                          </button>
                          <span>{item.quantity}</span>
                          <button
                            className="qty-btn"
                            onClick={() => handleQuantity(item.id, 1, item.quantity)}
                          >
                            <FiPlus size={12} />
                          </button>
                        </div>
                      </div>
                      <button
                        className="cart-item-remove"
                        onClick={() => handleRemove(item.id, item.name)}
                      >
                        <FiTrash2 size={16} />
                      </button>
                    </motion.div>
                  ))}
                </AnimatePresence>
              )}
            </div>

            {/* Footer */}
            {state.items.length > 0 && (
              <div className="drawer-footer">
                <div className="drawer-subtotal">
                  <span>Subtotal</span>
                  <span className="drawer-total">¥{totalPrice.toFixed(2)}</span>
                </div>
                <p className="drawer-shipping">Free shipping on orders over ¥9,900</p>
                <Link
                  to="/checkout"
                  className="btn btn-primary btn-full"
                  onClick={() => dispatch({ type: 'CLOSE_DRAWER' })}
                >
                  Proceed to Checkout
                </Link>
                <Link
                  to="/cart"
                  className="btn btn-ghost btn-full"
                  onClick={() => dispatch({ type: 'CLOSE_DRAWER' })}
                >
                  View Full Cart
                </Link>
              </div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CartDrawer;
